module.exports = __webpack_public_path__ + "static/media/JS4.165f680b.PNG";